import { Table } from '@ui';
import styled from 'styled-components';

export const TableSC = styled(Table)`
  /* td:last-child {
    text-align: right;
  } */
` as typeof Table;
